import dburl from '../utils/dburl';

export default function postComments(name, content,blogId) {
  const url = dburl + "comment";

  const option = {
    method:'POST',
    headers: {
      'Content-Type':'application/json'
    },
    body: JSON.stringify({
      blogId: parseInt(blogId),
      name,
      content
    })
  }
  
  return fetch(url,option)
  .then(res => res.json())
  .catch(err => {
    console.log(err)
    return {status:404}
  })
}